import type {
  TransactionRejectionReason,
  TransactionStatus,
} from "@/types/Wallet/transaction";

export const TRANSACTION_STATUS_DESCRIPTIONS: Record<
  TransactionStatus | "unknown",
  string
> = {
  authorization: "Authorized",
  pending: "Pending final amount",
  declined: "Declined",
  voided: "Voided",
  settled: "Processed",
  expired: "Expired",
  refunded: "Refunded",
  unknown: "Unknown",
};

export const TRANSACTION_REJECTION_REASON_DESCRIPTIONS: Record<
  NonNullable<TransactionRejectionReason>,
  string
> = {
  approved: "",
  invalid_vcn: "Invalid Card Number",
  insufficient_permissions: "",
  insufficient_funds: "Unexpected Error",
  cash_withdrawal: "Not Allowed",
  below_min_limit: "Below Card Minimum Limit",
  max_limit_exceeded: "Above Card Maximum Limit",
  rule_limit_exceeded: "Card Rule Limit Exceeded",
  spent_period_limit_exceeded: "Above Card Spend Period Limit",
  cloaked_merchant: "",
  card_expired: "Card Expired",
  max_transactions_exceeded: "Card Maximum Transactions Met",
  merchant_locked: "Card Merchant Locked",
  account_inactive: "",
  account_state_review: "",
  account_state_transaction_fail: "",
  auth_rule_allowed_country: "",
  auth_rule_allowed_mcc: "",
  auth_rule_blocked_country: "",
  auth_rule_blocked_mcc: "",
  avs_invalid: "",
  bank_connection_error: "Verify Funding",
  bank_not_verified: "Verify Funding",
  card_closed: "Card Closed",
  card_paused: "Card Paused",
  declined: "",
  do_not_honor_advice: "Network Declined",
  fraud_advice: "",
  ignored_ttl_expiry: "",
  inactive_account: "",
  incorrect_pin: "",
  insufficient_funds_preload: "Insufficient Funds",
  invalid_card_details: "Card Details Invalid",
  invalid_transaction: "",
  merchant_blacklist: "",
  original_not_found: "Processing Error",
  previously_completed: "",
  reputation_limit_exceeded: "",
  reputation_not_found: "",
  single_use_recharged: "Single-Use Card",
  switch_inoperative_advice: "Network Error",
  unauthorized_merchant: "",
  unknown: "Unexpected Error",
  unknown_host_timeout: "Network Error",
  user_in_collections: "Cloaked Balance Unpaid",
  user_transaction_limit: "Card Transaction Limit Met",
  velocity_exceeded: "",
  user_subscription_expired: "Cloaked Subscription Ended",
};
